import { render, staticRenderFns } from "./SolicitudPerfil.vue?vue&type=template&id=965ea2a0&scoped=true"
import script from "./SolicitudPerfil.vue?vue&type=script&lang=js"
export * from "./SolicitudPerfil.vue?vue&type=script&lang=js"
import style0 from "./SolicitudPerfil.vue?vue&type=style&index=0&id=965ea2a0&prod&scoped=true&lang=css"
import style1 from "./SolicitudPerfil.vue?vue&type=style&index=1&id=965ea2a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965ea2a0",
  null
  
)

export default component.exports